    import React, { useState, useRef, useEffect } from 'react';
    import { useAppDispatch, useAppSelector } from '../../app/hooks';
    import fetchAPI from '../../common/fetchAPI';
    import { ShowToast } from '../../common/Toastr';
    import DropdownOption from './DropDownOption';
    import { updateIsLoading, updateMasterFieldsByRowId, updateTimeEntriesAsync, updateDetailFieldsByDetailRowId } from './timesheetSlice';
    import { useTranslation } from "react-i18next";
    import { getValueFromResource } from '../../common/timeLiveFunction';
    const TimesheetCustomDropodown = (props: any) => {
        const getInitialCurrentStep = () => {
            if (isTimeOff && ShowProjectForTimeOff && showClient) {
                return 1;
            } else if (isTimeOff && ShowProjectForTimeOff && !showClient) {
                return 2;
            } else if (isTimeOff) {
                return 6;
            } else if (showClient) {
                return 1;
            } else {
                return 2;
            }
        }
        const defaultFocusRef = useRef<HTMLInputElement>(null);
        const { rowId, setDropdownVisible } = props;
        const { t } = useTranslation();
        const { showClient, showCostCenter, showWorkType, accountEmployeeId, timeEntriesList, accountEmployeeTimeEntryPeriodId, ShowProjectForTimeOff } = useAppSelector((state) => state.timesheet);
        const { isTimeOff } = timeEntriesList.find(x => x.rowId == rowId);
        const { showTimeOffTypesBy } = useAppSelector((state) => state.globalState)
        const [isLoading, setIsLoading] = useState(false);
        const [search, setSearch] = useState('');
        const [currentStep, setCurrentStep] = useState<number>(getInitialCurrentStep());
        const [stepOrder, setStepOrder] = useState([
            { step: 1, fieldIdName: "AccountClientId", fieldTextName: 'ClientName', required: null, data: [], selectedValue: 0, selectedText: '' },
            { step: 2, fieldIdName: "AccountProjectId", fieldTextName: 'ProjectName', required: "AccountClientId", data: [], selectedValue: 0, selectedText: '' },
            { step: 3, fieldIdName: "AccountProjectTaskId", fieldTextName: 'TaskName', required: "AccountProjectId", data: [], selectedValue: 0, selectedText: '' },
            { step: 4, fieldIdName: "AccountCostCenterId", fieldTextName: 'CostCenter', required: null, data: [], selectedValue: 0, selectedText: '' },
            { step: 5, fieldIdName: "AccountWorkTypeId", fieldTextName: 'WorkType', required: null, data: [], selectedValue: 0, selectedText: '' },
            { step: 6, fieldIdName: "AccountTimeOffTypeId", fieldTextName: 'AccountTimeOffType', required: null, data: [], selectedValue: 0, selectedText: '' }
        ]);
        const [updatedObject, setUpdatedObject] = useState<any>({});
        const dispatch = useAppDispatch();

        const getMaxStep = () => {
            if (isTimeOff) {
                return 6;
            } else if (showWorkType) {
                return 5;
            } else if (showCostCenter) {
                return 4;
            } else {
                return 3;
            }
        }

        const getDataByCurrentStep = (step: number) => {
            if (step == currentStep) {
                return stepOrder.find(x => x.step == currentStep)!.data;
            }
            else {
                return [];
            }
        }

        const handleTab = (step: number) => {
            const activeStep = stepOrder.find(x => x.step == step)!;
            if (activeStep.required != null) {
                if (updatedObject[activeStep.required] == 0)
                    return;
            }
            setCurrentStep(step);
            setSearch("");
        }

        const updateMasterRecord = () => {
            let TimeEntries = [] as any;
            var objMasterEntry = timeEntriesList.find(x => x.rowId == rowId);
            if (objMasterEntry) {
                TimeEntries = objMasterEntry.timeEntries
                    .filter((x: any) => x.AccountEmployeeTimeEntryId !== null)
                    .map((x: any) => x.AccountEmployeeTimeEntryId);
            }
            const selectedProject: any = stepOrder.find((step) => step.step === 2)?.data.find((item: any) => item.AccountProjectId === updatedObject.AccountProjectId);
            const rowUpdate = {
                ...updatedObject,
                RowId: rowId,
                ...(selectedProject ? {
                    ProjectName: selectedProject.ProjectName,
                    AdditionalProjectInfo: selectedProject.AdditionalProjectInfo ?? '',
                } : {}),
            };
            if (TimeEntries.length > 0) {
                const { AccountClientId, AccountProjectId, AccountProjectTaskId, AccountEmployeeTimeEntryApprovalProjectId, AccountWorkTypeId, AccountCostCenterId,IsBillable } = updatedObject;
                const postObject = {
                    AccountEmployeeId: accountEmployeeId,
                    AccountClientId,
                    AccountProjectId,
                    AccountProjectTaskId,
                    ApprovalProjectId: AccountEmployeeTimeEntryApprovalProjectId,
                    AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
                    TimeEntries,
                    IsDelete: false,
                    AccountWorkTypeId: AccountWorkTypeId,
                    AccountCostCenterId: AccountCostCenterId,
                    IsBillable : IsBillable
                }
                dispatch(updateIsLoading(true));
                dispatch(updateTimeEntriesAsync({ RowId: rowId, ...postObject }))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        // dispatch(updateMasterFieldsByRowId({ ...updatedObject, RowId: rowId }));
                        dispatch(updateMasterFieldsByRowId(rowUpdate));
                        ShowToast('Record updated successfully', 'Update', 'success');
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        dispatch(updateIsLoading(false));
                    });
            } else {
                // dispatch(updateMasterFieldsByRowId({ ...updatedObject, RowId: rowId }));
                dispatch(updateMasterFieldsByRowId(rowUpdate));
            }
        }

        useEffect(() => {
            if (currentStep > getMaxStep()) {
                updateMasterRecord();
                setDropdownVisible(false);
            } else {
                getDropdownData();
            }
        }, [currentStep])

        useEffect(() => {
            const { ClientName, ProjectName, TaskName, CostCenter, WorkType, AccountClientId, AccountProjectId, AccountProjectTaskId, AccountWorkTypeId, AccountCostCenterId, AccountTimeOffTypeId, AccountTimeOffType, AccountEmployeeTimeEntryApprovalProjectId } = timeEntriesList.find(x => x.rowId === rowId);
            setUpdatedObject({ AccountClientId, AccountProjectId, AccountProjectTaskId, AccountWorkTypeId, AccountCostCenterId, ClientName, ProjectName, TaskName, CostCenter, WorkType, AccountTimeOffTypeId, AccountTimeOffType, AccountEmployeeTimeEntryApprovalProjectId });
            if (defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            }
    
        }, [])
        
        useEffect(() => {
            if (currentStep === 1 && defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            } else if (currentStep === 2 && defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            }else if (currentStep === 3 && defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            }else if (currentStep === 4 && defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            }else if (currentStep === 5 && defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            }else if (currentStep === 6 && defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            }
        }, [currentStep]);
    
        const onSearchChange = (e: any) => {
            setSearch(e.target.value);
            
        }

        const stepHandler = (step: number, e: any) => {
            if (showCostCenter == false && step === 4) {
                setCurrentStep(step);
            }
            e.currentTarget.querySelector("input").checked = true;
            setSearch("");
            if (showClient && currentStep == 1) {
                setIsLoading(true);
                setCurrentStep(step);
                const index = stepOrder.findIndex((record) => record.step === currentStep);
                const newArray = [...stepOrder];
                newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
                newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;
                setStepOrder(newArray);
                setUpdatedObject({ ...updatedObject, [newArray[index].fieldIdName]: Number(e.currentTarget.querySelector("input").value), [newArray[index].fieldTextName]: e.currentTarget.querySelector(".name").innerText });
            } else if (currentStep == 2) {
                setIsLoading(true);
                setCurrentStep(step);
                const index = stepOrder.findIndex((record) => record.step === currentStep);
                const newArray = [...stepOrder];
                newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
                newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;
                setStepOrder(newArray)
                var FieldIdName = newArray[index].fieldIdName;
                var FieldTextName = newArray[index].fieldTextName;
                let AccountProjectId = Number(e.currentTarget.querySelector("input").value)
                let AccountClientId = newArray[index].data.filter((item: any) => item.AccountProjectId === AccountProjectId)[0]["AccountClientId"];
                showClient ?
                    setUpdatedObject({ ...updatedObject, [FieldIdName]: AccountProjectId, [FieldTextName]: e.currentTarget.querySelector(".name").innerText }) :
                    setUpdatedObject({ ...updatedObject, [FieldIdName]: AccountProjectId, [FieldTextName]: e.currentTarget.querySelector(".name").innerText, AccountClientId: AccountClientId });
            } else if (currentStep == 3) {
                setIsLoading(true);
                setCurrentStep(step);
                const index = stepOrder.findIndex((record) => record.step === currentStep);
                const newArray = [...stepOrder];
                newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
                newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;
                setStepOrder(newArray)
                var FieldIdName = newArray[index].fieldIdName;
                var FieldTextName = newArray[index].fieldTextName;
                var IsBillable = newArray[index].data.filter((x: any) => x.AccountProjectTaskId == Number(e.currentTarget.querySelector("input").value))[0]["IsBillable"];
                setUpdatedObject({ ...updatedObject, [FieldIdName]: Number(e.currentTarget.querySelector("input").value), [FieldTextName]: e.currentTarget.querySelector(".name").innerText, "IsBillable": IsBillable });
            } else if (showCostCenter && currentStep == 4) {
                setIsLoading(true);
                setCurrentStep(step);
                const index = stepOrder.findIndex((record) => record.step === currentStep);
                const newArray = [...stepOrder];
                newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
                newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;
                setStepOrder(newArray)
                var FieldIdName = newArray[index].fieldIdName;
                var FieldTextName = newArray[index].fieldTextName;
                setUpdatedObject({ ...updatedObject, [FieldIdName]: Number(e.currentTarget.querySelector("input").value), [FieldTextName]: e.currentTarget.querySelector(".name").innerText });
            } else if (showWorkType && currentStep == 5) {
                setIsLoading(true);
                setCurrentStep(step);
                const index = stepOrder.findIndex((record) => record.step === currentStep);
                const newArray = [...stepOrder];
                newArray[index].selectedValue = Number(e.currentTarget.querySelector("input").value);
                newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;
                setStepOrder(newArray)
                var FieldIdName = newArray[index].fieldIdName;
                var FieldTextName = newArray[index].fieldTextName;
                setUpdatedObject({ ...updatedObject, [FieldIdName]: Number(e.currentTarget.querySelector("input").value), [FieldTextName]: e.currentTarget.querySelector(".name").innerText });
            } else if (isTimeOff && currentStep == 6) {
                setIsLoading(true);
                setCurrentStep(step);
                const index = stepOrder.findIndex((record) => record.step === currentStep);
                const newArray = [...stepOrder];
                newArray[index].selectedValue = e.currentTarget.querySelector("input").value;
                newArray[index].selectedText = e.currentTarget.querySelector(".name").innerText;
                setStepOrder(newArray)
                var FieldIdName = newArray[index].fieldIdName;
                var FieldTextName = newArray[index].fieldTextName;
                setUpdatedObject({ ...updatedObject, [FieldIdName]: e.currentTarget.querySelector("input").value, [FieldTextName]: e.currentTarget.querySelector(".name").innerText });
            }
           
        }

        const getDropdownData = () => {
            const { AccountClientId, AccountProjectId } = updatedObject;
            if (currentStep == 1) {
                fetchAPI(`api/Timesheets/GetAccountClientForTimesheet/${accountEmployeeId}/${AccountClientId}`, 'GET', "", true)
                    .then(res => res.json())
                    .then((res) => {
                        setIsLoading(false);
                        const index = stepOrder.findIndex((record) => record.step === currentStep);
                        const newArray = [...stepOrder];
                        newArray[index].data = res;
                        setStepOrder(newArray)
                    }, (error) => console.log(error));
            } else if (currentStep == 2) {
                if (showClient && !AccountClientId) {
                    return;
                }
                const project_id = (AccountProjectId != undefined ? AccountProjectId : 0);
                const url = `${(showClient ? AccountClientId : project_id)}/${accountEmployeeId}`;
                //if (AccountClientId) {
                fetchAPI(`api/Projects/GetAccountProjectsForTimesheet/${url}`, 'GET', "", true)
                    .then(res => res.json())
                    .then((res) => {
                        setIsLoading(false);
                        const index = stepOrder.findIndex((record) => record.step === currentStep);
                        const newArray = [...stepOrder];
                        newArray[index].data = res;
                        setStepOrder(newArray)
                    })
                    .catch((error) => {
                    })
                //}
            } else if (currentStep == 3) {
                const url = `${AccountProjectId}/${accountEmployeeId}`;
                if (AccountProjectId) {
                    fetchAPI(`api/Timesheets/GetAccountProjectTasksForTimesheet/${url}`, 'GET', "", true)
                        .then(res => res.json())
                        .then((res) => {
                            setIsLoading(false);
                            const index = stepOrder.findIndex((record) => record.step === currentStep);
                            const newArray = [...stepOrder];
                            newArray[index].data = res;
                            setStepOrder(newArray)
                        }, (error) => console.log(error));
                }
            } else if (currentStep == 4) {
                fillCostCenterDropdown();
            } else if (currentStep == 5) {
                fillWorkTypeDropdown();
            } else if (currentStep == 6) {
                fillTimeOffTypeDropdown();
            }
        }

        const fillWorkTypeDropdown = () => {
            if (showWorkType) {
                fetchAPI("api/WorkTypes", 'GET', "", true)
                    .then(res => res.json())
                    .then((res) => {
                        setIsLoading(false);
                        const index = stepOrder.findIndex((record) => record.step === currentStep);
                        const newArray = [...stepOrder];
                        newArray[index].data = res.length > 0 && res[0].hasOwnProperty('Message') ? [] : res;
                        setStepOrder(newArray)
                    }, (error) => console.log(error));
            }
        }

        const fillCostCenterDropdown = () => {
            const { AccountProjectId, AccountProjectTaskId } = updatedObject;
            const url = `${accountEmployeeId}/${AccountProjectId}/${AccountProjectTaskId}`;
            if (showCostCenter && AccountProjectId && AccountProjectTaskId) {
                fetchAPI(`api/v2/CostCenter/GetAccountCostCenterForTimesheet/${url}`, "GET", "", true)
                    .then(res => res.json())
                    .then((res) => {
                        setIsLoading(false);
                        const index = stepOrder.findIndex((record) => record.step === currentStep);
                        const newArray = [...stepOrder];
                        newArray[index].data = res.length > 0 && res[0].hasOwnProperty('Message') ? [] : res;
                        setStepOrder(newArray)
                    }, (error) => console.log(error));
            }
        }

        const fillTimeOffTypeDropdown = () => {
            if (isTimeOff) {
                fetchAPI(`api/TimeOffTypes/GetTimeOff/${accountEmployeeId}/${showTimeOffTypesBy}`, "GET", "", true)
                    .then(res => res.json())
                    .then((res) => {
                        setIsLoading(false);
                        const index = stepOrder.findIndex((record) => record.step === currentStep);
                        const newArray = [...stepOrder];
                        newArray[index].data = res.length > 0 && res[0].hasOwnProperty('Message') ? [] : res;
                        setStepOrder(newArray)
                    }, (error) => console.log(error));
            }
        }
        
        return (
            <div className={"timelive-mega-picker"} style={{ willChange: "transform", width: "auto" }}>
                <nav className={"nav nav-pills"}>
                    {((showClient && !isTimeOff) || (showClient && ShowProjectForTimeOff && isTimeOff)) && <span onClick={e => handleTab(1)} className={"nav-link " + (currentStep == 1 ? "active" : "")} style={{ borderRadius: 0 }}>{getValueFromResource('Client',dispatch, t)}</span>}
                    {(ShowProjectForTimeOff && isTimeOff || !isTimeOff) && <span onClick={e => handleTab(2)} className={"nav-link " + (currentStep == 2 ? "active" : "")} data-tab="pills-projects" style={{ borderRadius: 0 }}>{getValueFromResource('Project',dispatch, t)}</span>}
                    {!isTimeOff && <span onClick={e => handleTab(3)} className={"nav-link " + (currentStep == 3 ? "active" : "")} data-tab="pills-tasks" style={{ borderRadius: 0 }}>{getValueFromResource('Task',dispatch, t)}</span>}
                    {showCostCenter && !isTimeOff && <span onClick={e => handleTab(4)} className={"nav-link " + (currentStep == 4 ? "active" : "")} data-tab="pills-cost-center" data-step="4" style={{ borderRadius: 0 }}>{getValueFromResource('Cost Center',dispatch, t)}</span>}
                    {showWorkType && !isTimeOff && <span onClick={e => handleTab(5)} className={"nav-link " + (currentStep == 5 ? "active" : "")} data-tab="pills-work-type" data-step="5" style={{ borderRight: 0 }}>{getValueFromResource('Work Type',dispatch, t)}</span>}
                    {isTimeOff && <span onClick={e => handleTab(6)} className={"nav-link " + (currentStep == 6 ? "active" : "")} data-tab="pills-time-off-type" data-step="6">{getValueFromResource('Time Off Type',dispatch, t)}</span>}
                </nav>
                <div className={"tmg--search"}>
                    <div className={"input-group"}>
                        <span className={"search--icon"}><i className={"fa fa-search"}></i></span>
                        <input type="text" onChange={onSearchChange} value={search} className={"form-control shadow-none"} ref={defaultFocusRef} placeholder={getValueFromResource("Search",dispatch, t)} style={{ fontSize: '1.1rem', height: 46 }} />
                    </div>
                </div>
                <div className={"tab-content"} style={{ maxHeight: 300, overflowY: 'auto' }}>
                    {showClient &&
                        <div className={"tab-pane tmg--tab-pane fade " + (currentStep == 1 ? "show active" : "")} role="tabpanel">
                            <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                                <tbody>
                                    {isLoading &&
                                        <tr>
                                            <td className="spinner-border" role="status" style={{ display: (isLoading ? 'flex' : 'none') }}>
                                                <span className="visually-hidden">
                                                    {/* {t('Loading...')} */}
                                                    {getValueFromResource('Loading...',dispatch, t)}
                                                    </span>
                                            </td>
                                        </tr>
                                    }
                                    {getDataByCurrentStep(1)
                                        .filter((x: any) => x.ClientName.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                        .map((x: any, i) =>
                                            <DropdownOption
                                                key={i}
                                                type={"client"}
                                                id={x.AccountClientId}
                                                name={x.ClientName}
                                                code=""
                                                checked={x.AccountClientId == updatedObject.AccountClientId}
                                                clickHandler={(e: any) => stepHandler(2, e)}
                                            />
                                        )}
                                    {!isLoading && getDataByCurrentStep(1).length == 0 &&
                                        <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                            <td>
                                                {/* {t('No Result(s) Found')} */}
                                                {getValueFromResource('No Result(s) Found',dispatch, t)}

                                                </td>
                                        </tr>}
                                </tbody>
                            </table>
                        </div>
                    }
                    <div className={"tab-pane tmg--tab-pane fade " + (currentStep == 2 ? "show active" : "")} role="tabpanel">
                        <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                            <tbody>
                                {isLoading &&
                                    <tr>
                                        <td>
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {getDataByCurrentStep(2)
                                    .filter((x: any) => x.ProjectName.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                    .map((x: any, i) =>
                                        <DropdownOption
                                            key={i}
                                            type={"project"}
                                            id={x.AccountProjectId}
                                            name={x.AdditionalProjectInfo ? `[${x.AdditionalProjectInfo}] ${x.ProjectName}` : x.ProjectName}
                                            code={x.ProjectCode}
                                            checked={x.AccountProjectId == updatedObject.AccountProjectId}
                                            clickHandler={(e: any) => stepHandler(isTimeOff ? 6 : 3, e)}
                                        />
                                    )}
                                {!isLoading && getDataByCurrentStep(2).length == 0 &&
                                    <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                        <td>
                                            {/* {t('No Result(s) Found')} */}
                                            {getValueFromResource('No Result(s) Found',dispatch, t)}

                                            </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                    <div className={"tab-pane tmg--tab-pane fade " + (currentStep == 3 ? "show active" : "")} role="tabpanel">
                        <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                            <tbody>
                                {isLoading &&
                                    <tr>
                                        <td>
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {getDataByCurrentStep(3)
                                    .filter((x: any) => x.TaskName.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                    .map((x: any, i) =>
                                        <DropdownOption
                                            key={i}
                                            type={"task"}
                                            id={x.AccountProjectTaskId}
                                            name={x.TaskName}
                                            code=""
                                            checked={x.AccountProjectTaskId == updatedObject.AccountProjectTaskId}
                                            //clickHandler={(e: any) => stepHandler(4, e)}
                                            clickHandler={(e: any) => stepHandler(!showCostCenter ? 5 : 4, e)}
                                        />
                                    )}
                                {!isLoading && getDataByCurrentStep(3).length == 0 &&
                                    <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                        <td>
                                            {/* {t('No Result(s) Found')} */}
                                            {getValueFromResource('No Result(s) Found',dispatch, t)}
                                            </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                    {showCostCenter &&
                        <div className={"tab-pane tmg--tab-pane fade" + (currentStep == 4 ? "show active" : "")} role="tabpanel">
                            <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                                <tbody>
                                    {isLoading &&
                                        <tr>
                                            <td>
                                                <span className='indicator-progress' style={{ display: 'block' }}>
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                </span>
                                            </td>
                                        </tr>
                                    }
                                    {getDataByCurrentStep(4).length > 0 && getDataByCurrentStep(4)
                                        .filter((x: any) => x.AccountCostCenter.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                        .map((x: any, i) =>
                                            <DropdownOption
                                                key={i}
                                                type={"task"}
                                                id={x.AccountCostCenterId}
                                                name={x.AccountCostCenter}
                                                code={x.AccountCostCenterCode}
                                                checked={x.AccountCostCenterId == updatedObject.AccountCostCenterId}
                                                clickHandler={(e: any) => stepHandler(5, e)}
                                            />
                                        )}
                                    {!isLoading && getDataByCurrentStep(4).length == 0 &&
                                        <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                            <td>
                                                {/* {t('No Result(s) Found')} */}
                                                {getValueFromResource('No Result(s) Found',dispatch, t)}
                                                </td>
                                        </tr>}
                                </tbody>
                            </table>
                        </div>
                    }
                    {showWorkType &&
                        <div className={"tab-pane tmg--tab-pane fade" + (currentStep == 5 ? "show active" : "")} role="tabpanel">
                            <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                                <tbody>
                                    {isLoading &&
                                        <tr>
                                            <td>
                                                <span className='indicator-progress' style={{ display: 'block' }}>
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                </span>
                                            </td>
                                        </tr>
                                    }
                                    {getDataByCurrentStep(5).length > 0 && getDataByCurrentStep(5)
                                        .filter((x: any) => x.AccountWorkType.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                        .map((x: any, i) =>
                                            <DropdownOption
                                                key={i}
                                                type={"task"}
                                                id={x.AccountWorkTypeId}
                                                name={x.AccountWorkType}
                                                code={x.AccountWorkTypeCode}
                                                checked={x.AccountWorkTypeId == updatedObject.AccountWorkTypeId}
                                                clickHandler={(e: any) => stepHandler(6, e)}
                                            />
                                        )}
                                    {!isLoading && getDataByCurrentStep(5).length == 0 &&
                                        <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                            <td>
                                                {/* {t('No Result(s) Found')} */}
                                                {getValueFromResource('No Result(s) Found',dispatch, t)}

                                                </td>
                                        </tr>}
                                </tbody>
                            </table>
                        </div>
                    }
                    <div className={"tab-pane tmg--tab-pane fade" + (currentStep == 6 ? "show active" : "")} role="tabpanel">
                        <table className={"tmg--selections table table-sm mb-0 table--selections"}>
                            <tbody>
                                {isLoading &&
                                    <tr>
                                        <td>
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {getDataByCurrentStep(6).length > 0 && getDataByCurrentStep(6)
                                    .filter((x: any) => x.AccountTimeOffType.toLowerCase().indexOf(search.toLowerCase()) != -1)
                                    .map((x: any, i) =>
                                        <DropdownOption
                                            key={i}
                                            type={"task"}
                                            id={x.AccountTimeOffTypeId}
                                            name={x.AccountTimeOffType}
                                            code=""
                                            checked={x.AccountTimeOffTypeId == updatedObject.AccountTimeOffTypeId}
                                            clickHandler={(e: any) => stepHandler(7, e)}
                                        />
                                    )}
                                {!isLoading && getDataByCurrentStep(6).length == 0 &&
                                    <tr className={"selection--option"} style={{ textAlign: "center" }}>
                                        <td>
                                            {/* {t('No Result(s) Found')} */}
                                            {getValueFromResource('No Result(s) Found',dispatch, t)}

                                            </td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }

    export default TimesheetCustomDropodown